import { render, staticRenderFns } from "./LandlordPropertySectionNav.vue?vue&type=template&id=05236036"
import script from "./LandlordPropertySectionNav.vue?vue&type=script&lang=js"
export * from "./LandlordPropertySectionNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports